import { ScreenWidth } from 'web-common/src/shared/Constants';

export const maxScreen = (screenWidth: ScreenWidth) => {
  return `@media (max-width: ${screenWidth})`;
};

export const minScreen = (screenWidth: ScreenWidth) => {
  return `@media (min-width: ${screenWidth})`;
};

export const minMaxScreen = ({ min, max }: { min: ScreenWidth; max: ScreenWidth }) => {
  return `@media (min-width: ${min}) and (max-width: ${max})`;
};
